import { UIText2 } from '@cian/ui-kit';

import { clsx } from 'clsx';
import { type FC, type PropsWithChildren } from 'react';

import styles from './QuickLinksLayout.css';

interface IQuickLinksLayoutProps {
  isNarrow: boolean;
}

export const QuickLinksLayout: FC<PropsWithChildren<IQuickLinksLayoutProps>> = ({ children, isNarrow }) => {
  return (
    <div className={clsx(styles['container'], { [styles['container-narrow']]: isNarrow })} data-testid="quick-links">
      <UIText2 color="text-secondary-default">Рекомендуем посмотреть</UIText2>
      {children}
    </div>
  );
};
